<template>
  <n-form size="large" :rules="rules" :model="model" class="login-format">
    <n-form-item-row label="Correo electrónico" path="email" class="login-format-field">
      <n-input
        v-model:value="model.email"
        placeholder="Correo electrónico" />
    </n-form-item-row>
    <n-form-item-row label="Contraseña" path="password" class="login-format-field">
      <n-input
        v-model:value="model.password"
        :type="showPassword ? 'text' : 'password'"
        placeholder="Contraseña">
        <template #suffix>
          <i
            v-if="!showPassword"
            class="icon-eye-close input-icon"
            @click="this.showPassword = !this.showPassword"></i>
          <i
            v-else
            class="icon-eye-open input-icon"
            @click="this.showPassword = !this.showPassword"></i>
        </template>
      </n-input>
    </n-form-item-row>
    <ErrorMessage v-if="error.length || this.requestError.length" :text="error || this.requestError" />

    <div class="d-flex justify-content-center align-items-center mt-1">
      <button class="btn confirm-btn btn-login" @click="returnData">Iniciar sesión</button>
    </div>
  </n-form>
</template>
<script>
import ErrorMessage from './errorMessage.vue';

export default {
  name: "login-form",
  props: {
    requestError: String
  },
  data() {
    return {
      model: {
        email: null,
        password: null,
      },
      showPassword: false,
      isTheFormValid: true,
      error: ""
    };
  },
  methods: {
    validateForm() {
      let regex = new RegExp("[A-Za-z0-9]+@[A-Za-z0-9]+.[A-Za-z]{2,3}");
      if (!this.model.email) {
        this.error = ("Por favor ingrese un correo electrónico");
        this.isTheFormValid = false;
      }
      if (!regex.test(this.model.email)) {
        this.error = ("Por favor ingrese una correo electrónico válido");
        this.isTheFormValid = false;
      }
      if (!this.model.password) {
        this.error = ("Por favor ingrese una contraseña");
        this.isTheFormValid = false;
      }
      if (this.model.password?.length < 8) {
        this.error = ("La contraseña debe tener al menos 8 caracteres");
        this.isTheFormValid = false;
      }
      if (this.model.password === this.model.password?.toLowerCase()) {
        this.error = ("La contraseña debe tener al menos 1 caracter en mayúscula");
        this.isTheFormValid = false;
      }
      if (!/\d/.test(this.model.password)) {
        this.error = ("La contraseña debe tener al menos 1 número");
        this.isTheFormValid = false;
      }
    },
    returnData() {
      this.error = "";
      this.validateForm();
      if (this.isTheFormValid) {
        this.$emit("dataIsValid", this.model);
      }
      this.isTheFormValid = true;
    }
  },
  components: { ErrorMessage }
}
</script>

<style scoped>
.login-format {
  width: 35rem;
}

.btn-login {
  margin-top: 15%;
}


@media screen and (max-width: 700px) {
  .login-format {
    width: 20rem;
  }
  .btn-login {
    margin-top: 10%;
    margin-bottom: 18%;
    width: 70%;
  }

  .login-format-field {
    width: 80%;
    margin-left: 10% !important;
  }
}
</style>